import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { SoftUIControllerProvider } from "context";
import { Toaster } from "react-hot-toast";
import store from "./api/store";
import { Provider } from "react-redux";
import GoogleMapsProvider from "components/location/googleMapProvider";
import { AuthProvider } from "./AuthContext";

ReactDOM.render(
  <BrowserRouter>
    {/* <GoogleMapsProvider> */}
    <Provider store={store}>
      <SoftUIControllerProvider>
        <div><Toaster
          position="bottom-right"
          reverseOrder={false}
          gutter={8}
          toastOptions={{
            duration: 3000,
            removeDelay: 1000,
            style: {
              background: '#fff',
              color: '#111',
              fontSize: '14px',
              fontWeight: '500',
              fontFamily: 'Roboto, sans-serif',
              padding: '16px 20px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
              border: '1px solid #f5f5f5',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
            },
            error: {
              icon: '❌',
            },
          }}
        /></div>
        <AuthProvider>
          <App />
        </AuthProvider>
      </SoftUIControllerProvider>
    </Provider>
    {/* </GoogleMapsProvider> */}
  </BrowserRouter>,
  document.getElementById("root")
);
